import { Component } from '@angular/core';

@Component({
    selector: 'session-idle-modal',
    template: `
        <p>
            Due to inactivity you are about to be logged out. <br />Please click continue if you
            want to stay logged in.
        </p>
    `
})
export class LsqSessionIdleModalComponent {}
